import {
  Typography,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Pagination,
  Button,
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'sonner';
import {
  fetchSearchedDataAnalytics,
  setDataAnalyticsPage,
  setDataAnalyticsPageSize,
} from '../../../../actions';
import { debounce } from 'lodash';
import DateComponent from '../../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';
import { renderDropdown } from '../../../../common/inputField';
import QsaHsaDfiDataAnalyticsTable from './QsaHsaDfiDataAnalyticsTable';
import IUIAnalyticsTable from './IUIAnalyticsTable';
import SemenFreezingAnalyticsTable from './SemenFreezingAnalyticsTable';
import { downloadDataAnalyticsReportsApi } from '../../../../api/andrologyApi';

function DataAnalyticsTable() {
  const dispatch = useDispatch();
  const { totalData, page, pageSize, loading } = useSelector(
    (state) => state.dataAnalyticsReducer,
  );
  const [searchValue, setSearchValue] = useState('');
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [localLoad, setLocalLoad] = useState(false);
  const [searchKey, setSearchKey] = useState('firstName');
  const [report, setReport] = useState('Select');
  const [sfrInventory, setSfrInventory] = useState({
    open: false,
    data: {},
  });

  const [iuiDetails, setIuiDetails] = useState({
    open: false,
    data: {},
  });

  const searchHandler = useCallback(
    debounce((searchValue) => {
      if (report !== 'Select') {
        toast.promise(
          dispatch(
            fetchSearchedDataAnalytics(
              page,
              pageSize,
              searchValue,
              searchKey === 'pid',
              searchKey === 'firstName',
              fromDate,
              toDate,
              report,
            ),
          ),
          {
            loading: 'Searching patients...',
            success: 'Patients Loaded',
            error: 'Failed to load patients',
          },
        );
      }
    }, 500), // Adjust the debounce delay as necessary
    [dispatch, pageSize, searchKey, page, fromDate, toDate, report],
  );

  useEffect(() => {
    searchHandler(searchValue);
  }, [searchValue, searchHandler, fromDate, toDate]);

  useEffect(() => {
    if (!loading) {
      setLocalLoad(false);
    }
  }, [loading]);

  const handleSearchChange = (event) => {
    if (searchKey === 'pid') {
      setSearchValue(event.target.value.toUpperCase().trim());
    } else {
      setSearchValue(event.target.value.trim());
    }
  };
  const handlePageChange = (event, value) => {
    dispatch(setDataAnalyticsPage(value));
  };

  const handlePageSizeChange = (event) => {
    dispatch(setDataAnalyticsPageSize(event.target.value));
  };

  const fetchOnDateChange = useCallback(() => {
    toast.promise(
      dispatch(
        fetchSearchedDataAnalytics(
          1,
          pageSize,
          searchValue,
          searchKey === 'pid',
          searchKey === 'firstName',
          fromDate,
          toDate,
          report,
        ),
      ),
      {
        loading: 'Searching patients...',
        success: 'Patients Loaded',
        error: 'Failed to load patients',
      },
    );
  }, [dispatch, fromDate, pageSize, report, searchKey, searchValue, toDate]);

  const handleReportSelection = (e, index, name) => {
    setLocalLoad(true);
    handlePageChange(null, 1, true);
    setReport(e.target.value);
  };

  const handleFromDateChange = (date, dateString) => {
    handlePageChange(null, 1, false);
    if (!dateString) {
      setFromDate(null);
    } else {
      setFromDate(dayjs(dateString).toDate());
    }
  };

  const handleToDateChange = (date, dateString) => {
    handlePageChange(null, 1, false);
    if (!dateString) {
      setToDate(null);
    } else {
      setToDate(dayjs(dateString).toDate());
    }
  };

  useEffect(() => {
    if (toDate || fromDate) {
      fetchOnDateChange();
    }
  }, [toDate, fromDate, fetchOnDateChange]);

  const excelDownloadHandler = async () => {
    try {
      const responsePromise = downloadDataAnalyticsReportsApi({
        searchValue,
        searchByName: searchKey === 'firstName',
        searchByPatientId: searchKey === 'pid',
        fromDate,
        toDate,
        reportType: report,
      });
      toast.promise(
        responsePromise.then((response) => {
          if (response.data?.payload) {
            const link = document.createElement('a');
            link.href = response.data.payload;
            link.download = `${report}_analytics_report.csv`; // default file name here
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          return response;
        }),
        {
          loading: 'Downloading report...',
          success: 'File downloaded successfully!',
          error: 'Failed to download report',
        },
      );
    } catch (error) {
      console.error('Error downloading report:', error);
    }
  };

  return (
    <div className="theme-blush">
      {!sfrInventory.open && !iuiDetails.open && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div style={{ width: '400px' }}>
            {renderDropdown(
              'Select Report',
              'selectReport',
              report,
              ['Select', 'QSA / HSA / DFI', 'Semen Freezing', 'IUI'],
              handleReportSelection,
            )}
          </div>
        </div>
      )}
      {report !== 'Select' && (
        <>
          {!sfrInventory.open && !iuiDetails.open && (
            <>
              <Typography variant="body1" gutterBottom>
                <span style={{ fontWeight: 'bold' }}>{report}</span>
              </Typography>
              <div style={{ display: 'flex' }}>
                <div
                  style={{
                    display: 'flex',
                    marginBottom: '10px',
                    width: '30vw',
                    border: '1px solid grey',
                    borderRadius: '12px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '0 auto',
                  }}
                >
                  <select
                    style={{
                      border: 'none',
                      borderRight: '1px solid grey',
                      borderRadius: '0',
                      borderTopLeftRadius: '12px',
                      borderBottomLeftRadius: '12px',
                    }}
                    className="col-md-5 custom-select"
                    value={searchKey}
                    onChange={(e) => {
                      setSearchKey(e.target.value);
                    }}
                    required
                  >
                    <option value="firstName">Name</option>
                    <option value="pid">Patient ID</option>
                  </select>

                  <input
                    style={{
                      border: 'none',
                      borderRadius: '0',
                      borderTopRightRadius: '12px',
                      borderBottomRightRadius: '12px',
                    }}
                    aria-label="Text input with dropdown button"
                    className="col-md-7 form-control"
                    type="text"
                    placeholder={`Search by ${searchKey === 'pid' ? 'patient id' : 'first name'}`}
                    onChange={handleSearchChange}
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    marginBottom: '10px',
                    width: '30vw',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '0 auto',
                  }}
                >
                  <div>
                    <span style={{ fontWeight: 'bold' }}>From: </span>
                    <DateComponent
                      value={fromDate}
                      handleDateChange={handleFromDateChange}
                      allowClear={true}
                    />
                  </div>
                  <div>
                    <span style={{ fontWeight: 'bold' }}>To: </span>
                    <DateComponent
                      value={toDate}
                      handleDateChange={handleToDateChange}
                      allowClear={true}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={excelDownloadHandler}
                    style={{ minWidth: '180px' }}
                  >
                    Export to Excel
                  </Button>
                </div>
              </div>
            </>
          )}
          {report === 'QSA / HSA / DFI' &&
            !sfrInventory.open &&
            !iuiDetails.open &&
            !loading &&
            !localLoad && <QsaHsaDfiDataAnalyticsTable />}
          {report === 'Semen Freezing' &&
            !iuiDetails.open &&
            !loading &&
            !localLoad && (
              <SemenFreezingAnalyticsTable
                sfrInventory={sfrInventory}
                setSfrInventory={setSfrInventory}
              />
            )}
          {report === 'IUI' && !loading && !sfrInventory.open && !localLoad && (
            <IUIAnalyticsTable
              iuiDetails={iuiDetails}
              setIuiDetails={setIuiDetails}
            />
          )}
          {!sfrInventory.open && !iuiDetails.open && (
            <>
              <Pagination
                count={Math.ceil(totalData / pageSize)}
                page={page}
                onChange={handlePageChange}
                color="primary"
                style={{
                  marginTop: '20px',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              />

              <FormControl
                variant="outlined"
                style={{ minWidth: 120, marginBottom: '20px' }}
              >
                <InputLabel id="page-size-label">Page Size</InputLabel>
                <Select
                  labelId="page-size-label"
                  id="page-size-select"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                  label="Page Size"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                </Select>
              </FormControl>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default DataAnalyticsTable;
